import React from 'react';
import { connect } from 'react-redux';
import { fetchMembershipPackages, selectMembershipPackage, addMembership } from '../../../../../../Redux/Actions/EndUser/MembershipAction';
import { getMyOrganizations } from '../../../../../../Redux/Actions/EndUser/AccountDetailsActions';
import { signupPlus, signupSubtract } from '../../../../../../Redux/Actions/SignupWizardActions';
import { fetchStates } from '../../../../../../Redux/Actions/CommonActions';
import { getCounties, setCounties } from '../../../../../../Redux/Actions/Admin/ManageDistrictActions';
import { DropDownList } from '@progress/kendo-react-dropdowns';
import MembershipType from './MembershipType';
import { Alert } from 'reactstrap';
import IsLoading from '../../../../../Shared/Loading/IsLoading';
import _ from 'lodash';
import axios from 'axios';
import { ROOT_API_URL } from '../../../../../../api-config';

// import { Input } from '@progress/kendo-react-inputs';
import queryString from 'query-string';
import { withRouter } from 'react-router-dom';
import './Membership.scss';
import { Input } from 'reactstrap';
import { auth } from '../../../../../../services/auth.service';

import PlacesAutocomplete, {
    geocodeByAddress,
    geocodeByPlaceId,
    getLatLng,
} from 'react-places-autocomplete';

class Membership extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            OrganizationName: "",
            OrganizationSelect: {
                organizationId: 0,
                organizationName: ''
            },
            OrganizationId: 0,
            OrganizationList: [],
            isGettingOrganizations: false,
            hasSelectedOrg: false,
            MailingAddress: "",
            MailingAddress1: "",
            MailingAddress2: "",
            MailingCity: "",
            MailingZip: "",
            Phone: "",
            MailingStateId: 1,
            MailingState: "",
            CountyObj: {countyId: 0, countyName: ""},
            FirstName: "",
            LastName: "",
            MembershipPackageId: 1,
            AspNetUserId: "",
            ReferredBy:"",
            StateObject: { id: 0, name: "" },
            StateDesc:  { id: 0, name: "" },
            County: "",
            MembershipPackageObject: { membershipPackageID: 0, description: "",cost:"" },
            AdditionalHead: 1,
            touched: {
                firstName: false,
                package: false,
                orgName: false,
                orgSelect: false,
                lastName: false,
                address1: false,
                address2: false,
                city: false,
                state: false,
                county: false,
                zip: false,
                phone: false,
                refferedBy:false,
            },
            IsSubscribed:false,
        };
    }

    handleAddressChange = address => {
        this.setState({ address });
    };

    handleSelect = (address) => {
        //console.log("auth header in counties", { headers: auth.authHeader() });

        axios.get(`${ROOT_API_URL}/ManageDistrict/GetCounties?stateId=${this.state.StateObject.id}`)
			.then((response) =>{
                this.props.setCounties(response.data);
                this.setState({ address });
                this.SetMailField(address, response.data);
            })
			.catch((response) => {
				console.log(response);
			});
    };

    fetchCountiesByStateId = async (id) => {
        return await axios.get(`${ROOT_API_URL}/ManageDistrict/GetCounties?stateId=${id}`).then((response) => {
            this.props.setCounties(response.data);
        });
    }

    setCountyAsync = async (stateId, county) => {
        await this.fetchCountiesByStateId(stateId);

        var countyLst = this.props.district.counties;
        countyLst.forEach(countyObj => {
            if (county.includes(countyObj.countyName)) {
                this.setState({
                    CountyObj: countyObj
                })
            }
        });
    }

    SetTopSuggestion = suggestions => {

        if (!_.isEqual(this.state.TopSuggestion, suggestions[0])) {
            this.setState({ TopSuggestion: suggestions[0] })
            this.SetMailField(suggestions[0].description);
        }
    }

    SetMailField = (address, countiesList) => {
        
        geocodeByAddress(address)
            .then(results => {

                results.map((addressResults) => {
                    var mailingInformation = {
                        MailingAddress: "",
                        MailingAddress1: "",
                        MailingCity: "",
                        MailingState: "",
                        MailingStateId: 0,
                        StateObject: { id: 0, name: "" },
                        MailingZip: "",
                        County: ""
                    }
                    addressResults.address_components.map((result) => {
                        if (result.types.includes("street_number")) {
                            mailingInformation.MailingAddress1 = result["short_name"];
                        }
                        if (result.types.includes("route")) {
                            mailingInformation.MailingAddress1 = mailingInformation.MailingAddress1 + " " + result["short_name"];
                        }
                        if (result.types.includes("locality")) {
                            mailingInformation.MailingCity = result["short_name"];
                        }
                        if (result.types.includes("administrative_area_level_1")) {
                            mailingInformation.MailingState = result["short_name"];
                            var stateObj = this.props.common.states.find((stateObj) => {
                                if (stateObj.name === result["short_name"].toString()) {
                                    return stateObj
                                }
                            });

                            if (stateObj) {

                                this.state.StateDesc = stateObj;
                                mailingInformation.StateObject = stateObj;

                                if (stateObj.id) {

                                    mailingInformation.MailingStateId = stateObj.id;

                                }
                            }

                        }
                        if (result.types.includes("administrative_area_level_2")) {
                            mailingInformation.County = result["long_name"];
                        }
                        if (result.types.includes("postal_code")) {
                            mailingInformation.MailingZip = result["short_name"];
                        }
                    });

                    //this.props.getCounties(mailingInformation.StateObject.id);
                    this.setState(mailingInformation);

                })

            }).then(() => {
                //this.selectCounty(this.state.County);
                this.setCountyAsync(this.state.StateObject.id, this.state.County);
            });
    }

    formatPhone = (val) => {
        if (!val) return val;
        var x = val.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
        return !x[2] ? x[1] : '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : '');
    }

    componentDidMount() {
        this.props.fetchStates();
        this.setUserId();
        // this.getMyOrganizations();
        if (this.props.membership.membershipInformation !== null) {
            this.setState({
                FirstName: this.props.membership.membershipInformation.FirstName,
                LastName: this.props.membership.membershipInformation.LastName,
                MailingAddress1: this.props.membership.membershipInformation.MailingAddress1,
                MailingAddress2: this.props.membership.membershipInformation.MailingAddress2,
                MailingCity: this.props.membership.membershipInformation.MailingCity,
                MailingZip: this.props.membership.membershipInformation.MailingZip,
                MailingStateId: this.props.membership.membershipInformation.MailingStateId,
                StateObject: {
                    name: this.props.membership.membershipInformation.StateObject.name,
                    id: this.props.membership.membershipInformation.StateObject.id
                },
                MembershipPackageObject: this.props.membership.membershipInformation.MembershipPackageObject,
                Phone: this.props.membership.membershipInformation.Phone,
                MembershipPackageId: this.props.membership.membershipInformation.MembershipPackageId,
                OrganizationName: this.props.membership.membershipInformation.OrganizationName,
                ReferredBy: this.props.membership.membershipInformation.ReferredBy,
                CountyObj: {
                    countyName: this.props.membership.membershipInformation.CountyObj.countyName,
                    countyId: this.props.membership.membershipInformation.CountyObj.countyId
                },
                County: this.props.membership.membershipInformation.County,
                AdditionalHead: this.props.membership.membershipInformation.AdditionalHead
            });
        }
        // var userId = auth.getAuthUserId();
        // console.log(userId)
    }

    componentDidUpdate() {
        if (this.state.isGettingOrganizations === false && this.props.gettingOrganizations === true) {
            this.setGettingOrganizations();
        } else if (this.state.isGettingOrganizations === true && this.props.gettingOrganizations === false) {
            this.setOrganizationList();
        }
    }

    setUserId() {
        if (this.props.membership.userId) {
            this.setState({
                UserId: this.props.membership.userId
            })
        } else {
            window.location = '/';
        }
    }

    handleChange = (event) => {
        this.setState({
            [event.target.name]: event.target.value
        });
    }

    handlePackageChange = (event) => {
        //console.log(event.target.value);
        this.setState({
            MembershipPackageObject: event.target.value,
            MembershipPackageId: event.target.value.membershipPackageID
        })
        this.props.selectMembershipPackage(event.target.value);
    }

    handleSubmit = (event) => {
        event.preventDefault();
        if (this.isModelValid()) {
            const newState = Object.assign({}, this.state);

            //console.log(this.props.membership);

            if (this.props.membership.selectedmembershipPackage !== null && this.props.membership.selectedmembershipPackage.description === "3000+ head" && this.props.membership.selectedMembershipType.description === "Standard") {
                newState.MembershipPackageObject.cost = this.state.MembershipPackageObject.cost + (1.36 * this.state.AdditionalHead);
                newState.ActualCost = newState.MembershipPackageObject.cost;
            } else if (this.props.membership.selectedMembershipType.description === "Student") {
                console.log(this.props.membership.membershipPackages[0]);

                newState.ActualCost = this.props.membership.membershipPackages[0].cost;
                newState.MembershipPackageId = this.props.membership.membershipPackages[0].MembershipPackageId;

                newState.MembershipPackageObject = this.props.membership.membershipPackages[0];

                this.setState({
                    MembershipPackageObject: this.props.membership.membershipPackages[0],
                    MembershipPackageId: this.props.membership.membershipPackages[0].membershipPackageID
                })
                this.props.selectMembershipPackage(this.props.membership.membershipPackages[0]);
            } else {
                newState.MembershipPackageObject.cost = this.state.MembershipPackageObject.cost;
                newState.ActualCost = newState.MembershipPackageObject.cost;
            }

            newState.AdditionalHead = parseInt(this.state.AdditionalHead);

            console.log(newState);

            this.setState({ newState })
            this.props.addMembership(newState);
            this.props.signupPlus(this.props.signupWizard.signupStep);
        } else {
            this.setAllTouchedTrue();
        }
    }

    handlePhoneChange = (event) => {
        event.target.value = this.formatPhone(event.target.value);
        this.setState({
            [event.target.name]: event.target.value
        });
    }

    setAllTouchedTrue() {
        this.setState({
            touched: {
                firstName: true,
                package: true,
                orgName: true,
                orgSelect: true,
                lastName: true,
                address1: true,
                address2: true,
                city: true,
                state: true,
                county: true,
                zip: true,
                phone: true,
                referredBy:true
            }
        })
    }

    handleState = (event) => {
        this.props.getCounties(event.target.value.id);
        this.setState({
            StateObject: event.target.value,
            MailingStateId: event.target.value.id
        })
    }

    selectCountyInDD = (event) => {
        this.setState({
            CountyObj: event.target.value
        })
    }

    selectCounty = (county) => {
        var countyLst = this.props.district.counties;
        countyLst.forEach(countyObj => {
            if(county.includes(countyObj.countyName)){
                this.setState({
                    CountyObj: countyObj
                })
            }
        });
    }

    isFreeAccount() {
        if (this.props.membership.selectedMembershipType && this.props.membership.selectedMembershipType.description === 'Student') {
            return true;
        } else {
            return false;
        }
    }

    isYoungProfessional() {
        if (this.props.membership.selectedmembershipPackage && this.props.membership.selectedmembershipPackage.membershipPackageID === 48) {
            return true;
        } else {
            return false;
        }
    }

    handleBlur = (field) => (evt) => {
        this.setState({
            touched: { ...this.state.touched, [field]: true },
        });
    }

    handleZipChange = (event) => {
        var originalValue = this.state.MailingZip;
        var value = event.target.value.replace(/\D/g, '');;
        if ((value.match(/^[0-99999]|^$/) || value == "") && value.length <= 5) {
            this.setState({
                MailingZip: value
            });
        }
        else {
            this.setState({
                MailingZip: originalValue
            });
        }
    }

    isModelValid() {
        if (this.isFreeAccount()) {
            return this.state.MailingAddress1 !== "" &&
            this.state.MailingCity !== "" &&
            this.state.MailingZip !== "" &&
            this.state.Phone !== "" &&
            this.state.MailingStateId !== "" &&
            this.state.FirstName !== "" &&
            this.state.LastName !== "" &&
            this.state.ReferredBy !== "" &&
            this.state.StateObject.name !== "" &&
            this.state.CountyObj.countyName !== "";
        } else {
            return (this.state.OrganizationName !== "" || this.state.OrganizationId > 0) &&
            this.state.MailingAddress1 !== "" &&
            this.state.MailingCity !== "" &&
            this.state.MailingZip !== "" &&
            this.state.Phone !== "" &&
            this.state.MailingStateId !== "" &&
            this.state.FirstName !== "" &&
            this.state.LastName !== "" &&
            this.state.StateObject.name !== "" &&
            this.state.CountyObj.countyName !== "" &&
            this.state.ReferredBy !== "" &&
            this.state.MembershipPackageObject.description !== "";
        }
    }
    
    handleCheckboxChange = event => {
        this.setState({ IsSubscribed: event.target.checked }
        );
    }

    displayAdditionalHeads = () => {
        if (this.props.membership.selectedmembershipPackage !== null && this.props.membership.selectedMembershipType.description !== undefined &&  this.props.membership.selectedMembershipType.description !== undefined) {
            if (this.props.membership.selectedmembershipPackage.description === "3000+ head" && this.props.membership.selectedMembershipType.description === "Standard") {
                return (
                    <div className="membershipID form-group">
                        <label htmlFor="AdditionalHead" className="">How many additional head over 3000?</label>
                        <Input
                            id="AdditionalHead"
                            min="1"
                            type="number"
                            value={this.state.AdditionalHead}
                            onChange={this.handleChange}
                            name="AdditionalHead"
                        />
                    </div>
                )
            }

        }
    }

    updateSelectedMembership = () => {
        this.setState({
            MembershipPackageObject: { membershipPackageID: 0, description: "", cost: "" }
        });
    }

    getMyOrganizations() {
        if (this.props.membership.userId) {
            this.props.getMyOrganizations(this.props.membership.userId);
        }
    }

    setGettingOrganizations() {
        this.setState({
            isGettingOrganizations: true
        });
    }

    setOrganizationList() {
        const organizationList = [
            {
                organizationId: -1,
                organizationName: '\"Add New Organization\"'
            },
            ...this.props.myOrganizations
        ];
        this.setState({
            OrganizationList: organizationList,
            isGettingOrganizations: false
        });
    }

    handleOrganizationSelect = (event) => {
        let organizationId = event.target.value.organizationId;
        if (organizationId === -1) {
            organizationId = 0;
        }
		const edited = this.state;
		edited.OrganizationSelect.organizationName = event.target.value.organizationName;
        edited.OrganizationSelect.organizationId = event.target.value.organizationId;
        edited.OrganizationId = organizationId;
        edited.hasSelectedOrg = true;

        this.setState({
            ...edited
        });
    }

    render() {
        // (!this.props.myOrganizations.length || (this.state.OrganizationId === 0 && this.state.touched.orgSelect)
        return (
            <div className="membershipFormContainer">
                <div className="cols">
                    {this.props.common.loading ? (
						<IsLoading />
					) : (
                    <div className="col-lg-8 col-left">
                        {this.props.common.visible ? (
                            <Alert
                                color={this.props.common.color}
                                isOpen={this.props.common.visible}
                                style={{ width: '100%' }}
                            >
                                {this.props.common.message}
                            </Alert>
                        ) : null}
                        <MembershipType updateSelectedMembership={this.updateSelectedMembership}/>
                        {(this.props.membership.selectedMembershipType && this.props.membership.selectedMembershipType.description !== '') ?
                            <form className="membershipForm" onSubmit={this.handleSubmit}>
                                    {!this.isFreeAccount() ? <div className="">
                                            <div className="adjust1">
                                    <label htmlFor="membershipPackageID" className={this.state.touched.package && this.state.MembershipPackageObject.description === '' ? "error" : ""}>
                                        How many head (cattle) in total are you responsible for? <span className="highlight no-break"></span>
                                                </label>
                                    </div>
                                    <DropDownList data={this.props.membership.membershipPackages}
                                        id="membershipPackageID"
                                        name="membershipPackageID"
                                        textField="description"
                                        dataItemKey="membershipPackageID"
                                        onChange={this.handlePackageChange}
                                        value={this.state.MembershipPackageObject}
                                        width={300}
                                        className={this.state.touched.package && this.state.MembershipPackageObject.description === '' ? "error" : ""}
                                        invalid={this.state.touched.package && this.state.MembershipPackageObject.description === '' ? true : false}
                                        onBlur={this.handleBlur('package')}
                                    />
                                    {
                                        this.displayAdditionalHeads()
                                    }
                                </div> : null}

                                {/*!this.isFreeAccount() ?

                                    (this.props.myOrganizations.length ?
                                        <div className="membershipID">
                                            <label htmlFor="OrganizationSelect" className={this.state.touched.orgSelect && this.state.OrganizationSelect.organizationName === '' ? "error" : ""}>Select Organization</label>
                                            <DropDownList data={this.state.OrganizationList}
                                                id="OrganizationSelect"
                                                name="OrganizationSelect"
                                                textField="organizationName"
                                                dataItemKey="organizationId"
                                                onChange={this.handleOrganizationSelect}
                                                value={this.state.OrganizationSelect}
                                                className={this.state.touched.orgSelect && this.state.OrganizationSelect.organizationName === '' ? "error" : ""}
                                                invalid={this.state.touched.orgSelect && this.state.OrganizationSelect.organizationName === '' ? true : false}
                                                onBlur={this.handleBlur('orgSelect')}
                                            />
                                        </div> : null
                                    )
                                    : null
                                */}

                                {!this.isFreeAccount() ?
                                    <div className="membershipID">
                                        <label htmlFor="OrganizationName" className={this.state.touched.orgName && this.state.OrganizationName === '' ? "error" : ""}>Family/Group/Organization Name - what name would you like on your membership ID card and magazine?</label>
                                        <Input
                                            id="OrganizationName"
                                            type="text"
                                            value={this.state.OrganizationName}
                                            onChange={this.handleChange}
                                            name="OrganizationName"
                                            invalid={this.state.touched.orgName && this.state.OrganizationName === '' ? true : false}
                                            onBlur={this.handleBlur('orgName')}
                                        />
                                    </div>
                                    : null
                                }

                                    <div className="membershipID">
                                        <label htmlFor="ReferredBy" className={this.state.touched.referredBy && this.state.ReferredBy === '' ? "error" : ""}>Recommended By/How did you hear about us?</label>
                                        <Input
                                            id="ReferredBy"
                                            type="text"
                                            value={this.state.ReferredBy}
                                            onChange={this.handleChange}
                                            name="ReferredBy"
                                            invalid={this.state.touched.referredBy && this.state.ReferredBy === '' ? true : false}
                                            onBlur={this.handleBlur('referredBy')}
                                        />
                                    </div> 
                                <div className="firstNameLastNameContainer">
                                    <div className="first-name-wrapper">
                                        <label htmlFor="FirstName" className={this.state.touched.firstName && this.state.FirstName === '' ? "error" : ""}>First Name</label>
                                        <Input
                                            id="FirstName"
                                            type="text"
                                            value={this.state.FirstName}
                                            onChange={this.handleChange}
                                            name="FirstName"
                                            invalid={this.state.touched.firstName && this.state.FirstName === '' ? true : false}
                                            onBlur={this.handleBlur('firstName')}
                                        />
                                    </div>
                                    <div className="last-name-wrapper">
                                        <label htmlFor="LastName" className={this.state.touched.lastName && this.state.LastName === '' ? "error" : ""}>Last Name</label>
                                        <Input
                                            id="LastName"
                                            type="text"
                                            value={this.state.LastName}
                                            onChange={this.handleChange}
                                            name="LastName"
                                            invalid={this.state.touched.lastName && this.state.LastName === '' ? true : false}
                                            onBlur={this.handleBlur('lastName')}
                                        />
                                    </div>
                                        </div>
                                        <h3>Enter your <span className="highlight">Mailing Address</span></h3>
                                        <div className="mailingAddressContainer">
                          {/*<label htmlFor="MailingAddressAuto">Mailing Address</label>

                                            <PlacesAutocomplete
                                                value={this.state.address || ""}
                                                onChange={this.handleAddressChange}
                                                onSelect={this.handleSelect}
                                            >
                                                {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
                                                            <div className="col-md-8">

                                                    <input style={{ width: "100%" }}
                                                            {...getInputProps({
                                                                placeholder: 'Search Places...'
                                                            })}
                                                        />
                                                                <div style={{width: "100%"}}>
                                                                    {loading && <div><p>Loading...</p></div>}
                                                                    {suggestions.length > 0 ? this.SetTopSuggestion(suggestions)
                                                                    :""}
                                                            {suggestions.map(suggestion => {
                                                                const className = suggestion.active
                                                                    ? 'suggestion-item--active'
                                                                    : 'suggestion-item';
                                                                const style = suggestion.active
                                                                    ? {
                                                                        backgroundColor: '#f0f0f0',
                                                                        cursor: 'pointer',
                                                                        width: '100%'
                                                                    }
                                                                    : {
                                                                        backgroundColor: '#ffffff',
                                                                        cursor: 'pointer',
                                                                        width: '100%'
                                                                    };
                                                                return (
                                                                    <div
                                                                        {...getSuggestionItemProps(suggestion, {
                                                                            className,
                                                                            style,
                                                                        })}
                                                                    >
                                                                        <span>{suggestion.description}</span>
                                                                    </div>
                                                                );
                                                            })}
                                                        </div>
                                                    </div>
                                                )}
                                            </PlacesAutocomplete>
                                            <div className="offset-md-4"></div>*/}


                                            <div className="address1-wrapper">
                                                <label htmlFor="MailingAddress1" className={this.state.touched.address1 && this.state.MailingAddress1 === '' ? "error" : ""}>Address 1</label>
                                                <Input
                                                    id="MailingAddress1"
                                                    type="text"
                                                    value={this.state.MailingAddress1}
                                                    onChange={this.handleChange}
                                                    name="MailingAddress1"
                                                    invalid={this.state.touched.address1 && this.state.MailingAddress1 === '' ? true : false}
                                                    onBlur={this.handleBlur('address1')}
                                                />
                                            </div>
                                            <div className="address2-wrapper">
                                                <label htmlFor="MailingAddress2">Address 2</label>
                                                <Input
                                                    id="MailingAddress2"
                                                    type="text"
                                                    value={this.state.MailingAddress2}
                                                    onChange={this.handleChange}
                                                    name="MailingAddress2"
                                                />
                                            </div>
                                        </div>
                                        <div className="cityStateZip">
                                            <div className="city-wrapper">
                                                <label htmlFor="MailingCity" className={this.state.touched.city && this.state.MailingCity === '' ? "error" : ""}>City</label>
                                                <Input
                                                    id="MailingCity"
                                                    type="text"
                                                    value={this.state.MailingCity}
                                                    onChange={this.handleChange}
                                                    name="MailingCity"
                                                    invalid={this.state.touched.city && this.state.MailingCity === '' ? true : false}
                                                    onBlur={this.handleBlur('city')}
                                                />
                                            </div>
                                            <div className="state-wrapper">
                                                <label htmlFor="State" className={this.state.touched.state && this.state.StateObject.name === '' ? "error" : ""}>State </label>
                                                <DropDownList data={this.props.common.states}
                                                    id="State"
                                                    name="State"
                                                    textField="name"
                                                    dataItemKey="id"
                                                    onChange={this.handleState}
                                                    value={this.state.StateObject}
                                                    className={this.state.touched.state && this.state.StateObject.name === '' ? "error" : ""}
                                                    onBlur={this.handleBlur('state')}
                                                />
                                            </div>
                                            {
                                                this.props.district.counties.length > 0 ? 
                                                <div className="state-wrapper">
                                                    <label htmlFor="County" className={this.state.touched.County === '' ? "error" : ""}>County</label>
                                                     <DropDownList data={this.props.district.counties}
                                                        id="County"
                                                        name="County"
                                                        textField="countyName"
                                                        dataItemKey="countyId"
                                                        onChange={this.selectCountyInDD}
                                                        value={this.state.CountyObj}
                                                        className={this.state.touched.county && this.state.CountyObj.countyName === '' ? "error" : ""}
                                                        onBlur={this.handleBlur('county')}
                                                    />
                                                </div> : ""
                                            }
                                            <div className="zip-wrapper">
                                                <label htmlFor="MailingZip" className={this.state.touched.zip && this.state.MailingZip === '' ? "error" : ""}>Zip</label>
                                                <Input
                                                    id="MailingZip"
                                                    vakudutystyles="false"
                                                    value={this.state.MailingZip}
                                                    onChange={this.handleZipChange}
                                                    name="MailingZip"
                                                    pattern="(\d{5}([\-]\d{4})?)"
                                                    type="text"
                                                    placeholder="12345"
                                                    title="Zip Code (Format: 12345 or 12345-6789)"
                                                    invalid={this.state.touched.zip && this.state.MailingZip === '' ? true : false}
                                                    onBlur={this.handleBlur('zip')}
                                                />
                                            </div>
                                    <div className="phone-wrapper">
                                        <label htmlFor="Phone" className={this.state.touched.phone && this.state.Phone === '' ? "error" : ""}>Phone</label>
                                        <Input
                                            id="Phone"
                                            type="text"
                                            value={this.state.Phone}
                                            vakudutystyles="false"
                                            // onChange={this.handleChange}
                                            onChange={this.handlePhoneChange}
                                            name="Phone"
                                            pattern="[\(]\d{3}[\)] \d{3}[\-]\d{4}"
                                            title="Phone Number (Format: (123) 456-7890)"
                                            placeholder="(123) 456-7890"
                                            onBlur={this.handleBlur('phone')}
                                            invalid = {this.state.touched.phone && !this.state.Phone && this.handlePhoneChange ? true : false}
                                        />
                                    </div>
                                </div>

                                {!this.isFreeAccount() && !this.isYoungProfessional() ?
                                    <div className="subscribed">
                                        <input
                                            type="checkbox"
                                            id="IsSubscribed"
                                            onChange={this.handleChange}
                                            name="IsSubscribed"
                                            checked={this.state.IsSubscribed}
                                            onChange={this.handleCheckboxChange}
                                        />
                                            <label htmlFor="IsSubscribed">
                                                <span className={ this.state.IsSubscribed ? " far fa-check-square" : "far fa-square"}></span>
                                                <span className="custom-control-text">I Want to Receive My Complimentary Cattleman Magazine Subscription</span>
                                            </label>
                                    </div>
                                : null }

                                <div className="vertHorzCenter buttonContainer">
                                    <button type="submit" className="signUpBtns mb-3 btnPrimary" tabIndex="0">NEXT STEP</button>
                                    <p>When you have answered all the fields, click the <span className="highlight">BLUE</span> "Next Step" to continue! </p>
                                </div>
                            </form>
                                : null}
                    </div>)}
                    
                    <div className="col-lg-4 col-right membershipBackground">
                        {/* <div className="membershipBackground"> 
                            <img src="/images/membershipBackground.jpg" alt="Cows on the land" />
                        </div> */}
                    </div>
                    
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        membership: state.membership,
        common: state.common,
        signupWizard: state.signupWizard,
        district: state.district,
        myOrganizations: state.accountDetails.myOrganizations,
        gettingOrganizations: state.accountDetails.gettingOrganizations,
    }
}

export default withRouter(connect(mapStateToProps, { setCounties, fetchMembershipPackages, selectMembershipPackage, addMembership, signupPlus, signupSubtract, fetchStates, getCounties, getMyOrganizations })(Membership));

